export function SET_USER(state, user) {
  state.user = user;
}
